/* Corpo in Seduta · landing IT v3 (2026-10-21) · total en vivo, botón de compra con consentimiento, barra fija desde la oferta,
   visor (también para la copia B del carrusel), contador REAL de los regalos (30-11-2026 23:59, Roma) y anclas con el scroll suave.
   Base: landing-cro/plantilla/landing-base.html; v2 en cs-landing-v2-2026-10-21.js. */
(function(){
  var d=document, $=function(s){return d.querySelector(s)}, $$=function(s){return Array.prototype.slice.call(d.querySelectorAll(s))};
  /* ---- Total en vivo, planes y bumps ---- */
  var moneda=d.body.dataset.moneda, locale=d.body.dataset.locale;
  function fmt(c){ try{ return new Intl.NumberFormat(locale,{style:'currency',currency:moneda,minimumFractionDigits:(c%100)?2:0}).format(c/100); }catch(e){ return (c/100).toFixed(2); } }
  function cent(el){ return parseInt(el.dataset.precio,10)||0; }
  function plan(){ return $('input[name=plan]:checked'); }
  function actualizar(){
    var p=plan(), completo=p&&p.value==='completo', c=p?cent(p):0;
    $$('.bump[data-en-completo]').forEach(function(b){ b.hidden=completo; if(completo) b.querySelector('input').checked=false; });
    $$('.extra').forEach(function(x){ if(x.checked) c+=cent(x); });
    if(c>0){ $('#total').textContent=fmt(c); }
    enlace();
  }
  /* ---- Botón de compra: carrito con variantes + atributo de consentimiento (sin tocar: routes.cart_url) ---- */
  var cb=$('#consent'), caja=$('#consent-caja'), msg=$('#consent-msg'), btn=$('#comprar-btn');
  function enlace(){
    if(!cb.checked){ btn.href='#comprar'; return; }
    var items=[plan().dataset.variante+':1'];
    $$('.extra').forEach(function(x){ if(x.checked) items.push(x.dataset.variante+':1'); });
    btn.href=btn.dataset.carrito+'/'+items.join(',')+'?attributes%5B'+encodeURIComponent(btn.dataset.atributo)+'%5D='+encodeURIComponent(btn.dataset.valor+' '+new Date().toISOString());
  }
  btn.addEventListener('click',function(e){
    if(!cb.checked){ e.preventDefault(); msg.hidden=false; caja.classList.add('error'); cb.setAttribute('aria-invalid','true'); cb.focus(); caja.scrollIntoView({block:'center'}); }
  });
  cb.addEventListener('change',function(){ if(cb.checked){ msg.hidden=true; caja.classList.remove('error'); cb.removeAttribute('aria-invalid'); } enlace(); });
  $$('input[name=plan], .extra').forEach(function(x){ x.addEventListener('change',actualizar); });
  actualizar();
  /* ---- Barra fija: solo DESDE la oferta (pasado el bloque de compra; SF-011), nunca antes ---- */
  var fija=$('#fija'), compra=$('#comprar'), tic=false;
  function barra(){ tic=false; var r=compra.getBoundingClientRect(); fija.classList.toggle('oculta', !(r.bottom<0)); }
  fija.classList.add('oculta'); window.addEventListener('scroll',function(){ if(!tic){ tic=true; requestAnimationFrame(barra); } },{passive:true}); barra();
  /* ---- Contador REAL: fecha de fin de los regalos (Arquitectura de oferta: 30-11-2026). Pasada la fecha, se oculta. ---- */
  $$('[data-fin]').forEach(function(cu){
    var fin=new Date(cu.getAttribute('data-fin')).getTime();
    var dd=cu.querySelector('[data-cu=d]'), hh=cu.querySelector('[data-cu=h]'), mm=cu.querySelector('[data-cu=m]');
    function pinta(){
      var s=Math.floor((fin-Date.now())/1000);
      if(isNaN(s)||s<=0){ cu.hidden=true; return false; }
      var g=Math.floor(s/86400), h=Math.floor(s%86400/3600), m=Math.floor(s%3600/60);
      dd.textContent=g; hh.textContent=(h<10?'0':'')+h; mm.textContent=(m<10?'0':'')+m;
      return true;
    }
    if(pinta()) setInterval(pinta,30000);
  });
  /* ---- Galería ampliable (lightbox con <dialog>); la copia B del carrusel abre la misma imagen ---- */
  var lb=$('#lb'), img=$('#lb-img'), pie=$('#lb-pie'), btns=$$('[data-lb]'), i=0;
  function ver(n){ i=(n+btns.length)%btns.length; var s=btns[i].querySelector('img'); img.src=btns[i].dataset.grande||s.currentSrc||s.src; img.alt=s.alt; pie.textContent=(i+1)+' / '+btns.length; }
  function abrir(n){ ver(n); if(lb.showModal) lb.showModal(); else window.open(img.src); }
  btns.forEach(function(b,n){ b.addEventListener('click',function(){ abrir(n); }); });
  $$('[data-lb-alias]').forEach(function(b){ b.addEventListener('click',function(){ var k=+b.getAttribute('data-lb-alias'); var n=btns.findIndex(function(x){ return +x.dataset.lb===k; }); abrir(n<0?0:n); }); });
  $('#lb-ant').onclick=function(){ver(i-1)}; $('#lb-sig').onclick=function(){ver(i+1)}; $('#lb-cerrar').onclick=function(){lb.close()};
  lb.addEventListener('click',function(e){ if(e.target===lb) lb.close(); });
  lb.addEventListener('keydown',function(e){ if(e.key==='ArrowRight') ver(i+1); if(e.key==='ArrowLeft') ver(i-1); });
  /* ---- Anclas internas con el scroll suave (Lenis de movimiento-pro, solo ratón/trackpad) ---- */
  d.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href^="#"]'); if(!a||e.defaultPrevented||!window.lenisPagina) return;
    var h=a.getAttribute('href'); if(h.length<2) return; var t=null; try{ t=d.querySelector(h); }catch(err){ return; }
    if(!t) return; e.preventDefault(); window.lenisPagina.scrollTo(t,{offset:-72,duration:1.1});
  });
})();
